import { render, staticRenderFns } from "./CardInfo.vue?vue&type=template&id=f1d314fc&scoped=true&"
import script from "./CardInfo.vue?vue&type=script&lang=ts&"
export * from "./CardInfo.vue?vue&type=script&lang=ts&"
import style0 from "./CardInfo.vue?vue&type=style&index=0&id=f1d314fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1d314fc",
  null
  
)

export default component.exports